import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { dynaDocsModelInitialState, DynaDocsModelStateProps, dynaDocsModelStateStore } from './dyna-docs-model-state.store';
import { select } from '@ngneat/elf';

@Injectable({ providedIn: 'root' })
export class DynaDocsModelRepository extends BaseStoreRepository<DynaDocsModelStateProps> {
  constructor() {
    super(dynaDocsModelStateStore.pipe(select(state => state)), dynaDocsModelStateStore, dynaDocsModelInitialState);
  }
}
